/**
 * Shared limits + content-type allowlist for the in-app feedback widget.
 *
 * Single source of truth so the frontend Sheet (size hints, accept= hint),
 * the backend route validator, and the typed client all stay in lockstep.
 */
export const FEEDBACK_LIMITS = {
  maxAttachments: 5,
  maxAttachmentBytes: 10 * 1024 * 1024, // 10 MB per file
  maxTotalBytes: 25 * 1024 * 1024, // 25 MB combined
  maxSubjectLength: 200,
  maxMessageLength: 10_000,
} as const;

/**
 * Backend allowlist of acceptable attachment content types. The frontend
 * `accept=` attribute is a UI hint only — this list is the security
 * boundary enforced server-side. Add to it deliberately; we don't want
 * arbitrary executables flowing into ops's inbox.
 */
export const FEEDBACK_ALLOWED_CONTENT_TYPES: readonly string[] = [
  // Images
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  // Documents
  'application/pdf',
  'text/plain',
  'text/csv',
  'application/json',
  'text/markdown',
  // Spreadsheets
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  // Archives (logs / bundles)
  'application/zip',
  'application/x-zip-compressed',
  // Logs frequently arrive as text/plain or octet-stream from the file picker.
  'application/octet-stream',
];
